import React, { useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import performanceService from '../../../services/data/performance.service';


const RATING_OPTIONS = [
    { label: '⬇️ Pode melhorar', value: '-1' },
    { label: '➡️ Esse é o caminho', value: '0' },
    { label: '⭐ Você brilhou!', value: '1' },
];

export default function FormGiveFeedback({ employee, feedbackRequest, onSuccess }) {
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            rating: '',
            comment: '',
        },
        validationSchema: Yup.object({
            rating: Yup.string().required('Selecione uma avaliação'),
            comment: Yup.string().required('Escreva seu feedback').min(10, 'Mínimo de 10 caracteres'),
        }),
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            const data = {
                company_id: localStorage.getItem('companyId'),
                employee_id: employee?.id,
                rating: values.rating,
                comment: values.comment,
            };
            if (feedbackRequest?.id) {
                data.feedback_id = feedbackRequest.id;
            }

            performanceService.giveFeedback(data).then(() => {
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Feedback enviado com sucesso!', life: 3000 });
                resetForm();
                if (onSuccess) setTimeout(() => onSuccess(), 1500);
            }).catch((error) => {
                const msg = error?.response?.data?.[0] || 'Erro ao enviar feedback';
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: msg, life: 4000 });
            }).finally(() => setLoading(false));
        },
    });

    return (
        <>
            <Toast ref={toast} position="top-right" />

            {feedbackRequest && (
                <div className="alert alert-light border mb-3">
                    <p className="fw-bold mb-1">{feedbackRequest.title}</p>
                    <p className="text-muted small mb-0" dangerouslySetInnerHTML={{ __html: feedbackRequest.description }} />
                </div>
            )}

            <form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                    <label className="form-label fw-bold">
                        Avaliação <span className="text-danger">*</span>
                    </label>
                    <Dropdown
                        name="rating"
                        placeholder="Selecionar avaliação"
                        value={formik.values.rating}
                        options={RATING_OPTIONS}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(e) => formik.setFieldValue('rating', e.value)}
                        className="w-100"
                    />
                    {formik.errors.rating && (
                        <span className="text-danger small">{formik.errors.rating}</span>
                    )}
                </div>

                <div className="mb-3">
                    <label className="form-label fw-bold">
                        Comentário <span className="text-danger">*</span>
                    </label>
                    <textarea
                        name="comment"
                        rows={4}
                        className="form-control"
                        placeholder="Descreva seu feedback com detalhes..."
                        value={formik.values.comment}
                        onChange={formik.handleChange}
                    />
                    {formik.errors.comment && (
                        <span className="text-danger small">{formik.errors.comment}</span>
                    )}
                </div>

                <div className="d-flex gap-2 justify-content-end">
                    
                    <button type="submit" className="btn btn-success btn-sm btn-rounded px-3" disabled={loading}>
                        {loading ? 'Enviando...' : 'Enviar Feedback'}
                    </button>
                </div>
            </form>
        </>
    );
}
